// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExplorePopularSearchWrapper_wrapper__s9qqW","search-item":"ExplorePopularSearchWrapper_search-item__HRGDG","selected":"ExplorePopularSearchWrapper_selected__KOn6E"};